<div class="min-h-screen bg-gray-900">
  <app-notification></app-notification>
  <div class="py-10">
    <header>
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between gap-4">
          <h1 class="text-3xl font-bold leading-tight tracking-tight text-white flex-shrink-0">Products</h1>
          <div class="flex items-center space-x-4 flex-1 justify-end min-w-0">
            <button
              (click)="openAddProductModal()"
              class="inline-flex items-center px-6 py-2.5 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 flex-shrink-0"
            >
              <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              Add Product
            </button>
            <div class="max-w-md w-full min-w-[200px]">
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  id="filter"
                  [(ngModel)]="filterText"
                  (input)="onFilterChange()"
                  placeholder="Search by name or ID..."
                  class="block w-full pl-10 pr-3 py-2 border border-gray-600 rounded-lg bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main>
      <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <!-- Product List -->
        <div class="mt-8 flow-root">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table class="min-w-full divide-y divide-gray-700">
                <thead>
                  <tr>
                    <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-0">
                      <button 
                        type="button"
                        (click)="onSort('id')"
                        class="flex items-center space-x-1 hover:text-indigo-300 transition-colors"
                      >
                        <span>ID</span>
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="getSortIcon('id')" />
                        </svg>
                      </button>
                    </th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-white">
                      <button 
                        type="button"
                        (click)="onSort('name')"
                        class="flex items-center space-x-1 hover:text-indigo-300 transition-colors"
                      >
                        <span>Name</span>
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="getSortIcon('name')" />
                        </svg>
                      </button>
                    </th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-white">Price</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-white">Stock</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-white">Domains</th>
                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0">
                      <span class="sr-only">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-800">
                  <tr *ngFor="let product of products$ | async">
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-white sm:pl-0">
                      {{ product.id }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-300">
                        <span>{{ product.acf.naam_nl | truncate:40 }}</span>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-300">
                      <!-- Products without price options -->
                      <div *ngIf="!hasPriceOptions(product)" class="flex items-center">
                        <!-- Display price when not editing -->
                        <span *ngIf="!product.isEditingPrice" (click)="startEditingPrice(product)" class="cursor-pointer hover:text-indigo-300">
                          {{ formatPrice(product.price) }}
                        </span>
                        
                        <!-- Edit price input when editing -->
                        <div *ngIf="product.isEditingPrice" class="flex items-center space-x-2">
                          <input 
                            type="number" 
                            step="0.01"
                            class="w-24 px-2 py-1 text-gray-900 bg-white rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                            [(ngModel)]="product.editPrice" 
                            (keyup.enter)="savePrice(product)"
                          >
                          <!-- Save button icon -->
                          <button type="button" (click)="savePrice(product)" class="text-indigo-400 hover:text-indigo-300">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                            </svg>
                          </button>
                        </div>
                      </div>

                      <!-- Products with price options -->
                      <div *ngIf="hasPriceOptions(product)" class="flex flex-col">
                        <!-- Price options toggle button -->
                        <button 
                          type="button" 
                          (click)="togglePriceOptionsView(product)" 
                          class="text-left text-indigo-400 hover:text-indigo-300 flex items-center"
                        >
                          <span>{{ product.price_options?.length }} price options</span>
                          <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            class="h-4 w-4 ml-1" 
                            [class.transform]="product.showPriceOptions" 
                            [class.rotate-180]="product.showPriceOptions" 
                            viewBox="0 0 20 20" 
                            fill="currentColor"
                          >
                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                          </svg>
                        </button>

                        <!-- Price options list (expanded view) -->
                        <div *ngIf="product.showPriceOptions" class="mt-2 space-y-2">
                          <div *ngFor="let option of product.price_options" class="flex flex-col text-xs bg-gray-800 p-2 rounded">
                            <span class="font-medium text-white">{{ option.name_nl }}</span>
                            
                            <!-- Price display when not editing -->
                            <div *ngIf="!option.isEditing" class="flex justify-between items-center mt-1">
                              <span (click)="startEditingPriceOption(option)" class="cursor-pointer hover:text-indigo-300">
                                {{ formatPrice(option.price) }}
                              </span>
                            </div>
                            
                            <!-- Price editing for option -->
                            <div *ngIf="option.isEditing" class="flex items-center space-x-2 mt-1">
                              <input 
                                type="number" 
                                step="0.01"
                                class="w-20 px-2 py-1 text-gray-900 bg-white rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-xs"
                                [(ngModel)]="option.editPrice" 
                                (keyup.enter)="savePriceOption(product, option)"
                              >
                              <!-- Save button icon -->
                              <button type="button" (click)="savePriceOption(product, option)" class="text-indigo-400 hover:text-indigo-300">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm">
                        <button 
                            type="button"
                            (click)="toggleStatus(product)"
                            [class]="'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 ' + 
                            (product.stock_status === 'instock' ? 'bg-indigo-600' : 'bg-gray-700')"
                            role="switch"
                            [attr.aria-checked]="product.stock_status === 'instock'"
                        >
                            <span class="sr-only">Toggle stock status</span>
                            <span
                                [class]="'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ' +
                                (product.stock_status === 'instock' ? 'translate-x-5' : 'translate-x-0')"
                            >
                                <span
                                    [class]="'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity ' +
                                    (product.stock_status === 'instock' ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in')"
                                    aria-hidden="true"
                                >
                                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span
                                    [class]="'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity ' +
                                    (product.stock_status === 'instock' ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out')"
                                    aria-hidden="true"
                                >
                                    <svg class="h-3 w-3 text-indigo-600" fill="currentColor" viewBox="0 0 12 12">
                                        <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                    </svg>
                                </span>
                            </span>
                        </button>
                    </td>
                    <td class="px-3 py-4 text-sm text-gray-300 relative" *ngIf="product.id">
                      <!-- Display mode -->
                      <div *ngIf="!editingDomains[product.id!]" class="flex items-center space-x-2">
                        <div class="relative group">
                          <button 
                            type="button"
                            (click)="toggleDomainEditor(product)"
                            class="inline-flex items-center space-x-1 text-xs text-indigo-400 hover:text-indigo-300 transition-colors cursor-pointer"
                          >
                            <span>{{ getDomainDisplay(product) }}</span>
                            <svg *ngIf="getDomainList(product).length > 0" class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                            </svg>
                          </button>
                          <!-- Domain list tooltip -->
                          <div *ngIf="getDomainList(product).length > 0 && !editingDomains[product.id!]" class="absolute z-50 invisible group-hover:visible bg-gray-800 rounded-lg border border-gray-700 shadow-xl p-3 mt-2 min-w-[200px] max-w-[300px] max-h-64 overflow-y-auto">
                            <div class="text-xs font-semibold text-gray-300 mb-2">Domains ({{ getDomainList(product).length }})</div>
                            <div class="space-y-1">
                              <div *ngFor="let domain of getDomainList(product)" class="text-xs text-gray-400">
                                {{ domain }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Edit mode -->
                      <div *ngIf="editingDomains[product.id!]" class="bg-gray-800 rounded-lg p-3 border border-gray-700 shadow-lg z-50 min-w-[200px]">
                        <div class="space-y-2 max-h-48 overflow-y-auto">
                          <div *ngFor="let domain of availableDomains" class="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              [checked]="isDomainSelected(product, domain)"
                              (change)="toggleDomainSelection(product, domain)"
                              [id]="'domain-' + product.id + '-' + domain"
                              class="rounded border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-offset-0"
                            />
                            <label 
                              [for]="'domain-' + product.id + '-' + domain"
                              class="text-sm text-gray-300 cursor-pointer"
                            >
                              {{ domain }}
                            </label>
                          </div>
                        </div>
                        <div class="flex items-center justify-end space-x-2 mt-3 pt-3 border-t border-gray-700">
                          <button
                            type="button"
                            (click)="editingDomains[product.id!] = false"
                            class="px-3 py-1.5 text-xs font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-md transition-colors"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            (click)="saveDomains(product)"
                            class="px-3 py-1.5 text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition-colors"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </td>
                    <td *ngIf="!product.id" class="px-3 py-4 text-sm text-gray-300">-</td>
                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                      <div class="flex items-center justify-end space-x-2">
                        <!-- WC Sync check button -->
                        <button
                          type="button"
                          (click)="openSyncCheck(product)"
                          class="text-gray-400 hover:text-orange-400 transition-colors"
                          title="WooCommerce sync check"
                        >
                          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                          </svg>
                        </button>
                        <!-- Edit button -->
                        <button
                          type="button"
                          (click)="editProduct(product)"
                          class="text-indigo-400 hover:text-indigo-300 inline-flex items-center"
                        >
                          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                          <span class="sr-only">Edit {{ product.id }}</span>
                        </button>
                        <!-- Delete button -->
                        <button
                          type="button"
                          (click)="confirmDelete(product)"
                          class="text-red-400 hover:text-red-300 inline-flex items-center"
                        >
                          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>

<!-- Add Product Modal -->
<div *ngIf="showAddProductModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="closeAddProductModal()"></div>

  <!-- Modal container -->
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative transform overflow-hidden rounded-2xl bg-gradient-to-br from-gray-800 to-gray-900 px-6 pb-6 pt-6 text-left shadow-2xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-8 border border-gray-700/50" (click)="$event.stopPropagation()">
      <!-- Close button -->
      <button
        (click)="closeAddProductModal()"
        class="absolute right-4 top-4 text-gray-400 hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg p-1"
        aria-label="Close modal">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Modal content -->
      <div class="mt-2">
        <h3 class="text-lg font-semibold leading-6 text-gray-200 mb-6" id="modal-title">
          Product toevoegen
        </h3>

        <div class="space-y-4">
          <!-- Product name -->
          <div>
            <label for="new-product-name" class="block text-sm font-medium text-gray-300 mb-1">Productnaam (NL) *</label>
            <input
              type="text"
              id="new-product-name"
              [(ngModel)]="newProduct.naam_nl"
              placeholder="Voer productnaam in"
              class="block w-full px-3 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>

          <!-- SKU -->
          <div>
            <label for="new-product-sku" class="block text-sm font-medium text-gray-300 mb-1">SKU</label>
            <input
              type="text"
              id="new-product-sku"
              [(ngModel)]="newProduct.sku"
              placeholder="Bijv. PROD-001"
              class="block w-full px-3 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>

          <!-- Price and Stock row -->
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="new-product-price" class="block text-sm font-medium text-gray-300 mb-1">Prijs (&euro;)</label>
              <input
                type="number"
                id="new-product-price"
                [(ngModel)]="newProduct.price"
                step="0.01"
                min="0"
                class="block w-full px-3 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label for="new-product-stock" class="block text-sm font-medium text-gray-300 mb-1">Voorraad</label>
              <input
                type="number"
                id="new-product-stock"
                [(ngModel)]="newProduct.stock_quantity"
                min="0"
                class="block w-full px-3 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
          </div>

          <!-- Stock status -->
          <div>
            <label for="new-product-status" class="block text-sm font-medium text-gray-300 mb-1">Voorraadstatus</label>
            <select
              id="new-product-status"
              [(ngModel)]="newProduct.stock_status"
              class="block w-full px-3 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="instock">Op voorraad</option>
              <option value="outofstock">Niet op voorraad</option>
              <option value="onbackorder">Nabestelling</option>
            </select>
          </div>
        </div>

        <p class="text-xs text-gray-500 mt-4">Na aanmaken wordt je doorgestuurd naar de bewerkpagina voor alle overige velden.</p>

        <!-- Actions -->
        <div class="flex items-center justify-end space-x-3 mt-6 pt-4 border-t border-gray-700">
          <button
            type="button"
            (click)="closeAddProductModal()"
            class="px-4 py-2 text-sm font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
          >
            Annuleren
          </button>
          <button
            type="button"
            (click)="saveNewProduct()"
            [disabled]="isAddingProduct"
            class="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg *ngIf="isAddingProduct" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isAddingProduct ? 'Toevoegen...' : 'Toevoegen' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- WooCommerce Sync Check Modal -->
<div *ngIf="showSyncModal" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="closeSyncModal()"></div>

  <div class="flex min-h-full items-center justify-center p-4 sm:p-0">
    <div class="relative transform overflow-hidden rounded-2xl bg-gradient-to-br from-gray-800 to-gray-900 px-6 pb-6 pt-6 text-left shadow-2xl sm:my-8 sm:w-full sm:max-w-2xl sm:p-8 border border-gray-700/50" (click)="$event.stopPropagation()">
      <!-- Close button -->
      <button (click)="closeSyncModal()" class="absolute right-4 top-4 text-gray-400 hover:text-gray-200 transition-colors focus:outline-none rounded-lg p-1">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div class="mt-2">
        <h3 class="text-lg font-semibold text-gray-200 mb-1">WooCommerce Sync Check</h3>
        <p class="text-sm text-gray-400 mb-6">{{ syncProduct?.acf?.naam_nl }}</p>

        <!-- Loading state -->
        <div *ngIf="syncCheckLoading" class="flex items-center justify-center py-12">
          <svg class="animate-spin h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="ml-3 text-gray-400">Vergelijken met WooCommerce...</span>
        </div>

        <!-- Result -->
        <div *ngIf="!syncCheckLoading && syncCompareResult">

          <!-- Not linked -->
          <div *ngIf="!syncCompareResult.linked" class="bg-yellow-900/20 border border-yellow-700/50 rounded-lg p-4 mb-4">
            <div class="flex items-center">
              <svg class="h-5 w-5 text-yellow-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
              <span class="text-yellow-300 text-sm">{{ syncCompareResult.message }}</span>
            </div>
          </div>

          <!-- WC product not found -->
          <div *ngIf="syncCompareResult.wcNotFound" class="bg-red-900/20 border border-red-700/50 rounded-lg p-4 mb-4">
            <div class="flex items-center">
              <svg class="h-5 w-5 text-red-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              <span class="text-red-300 text-sm">{{ syncCompareResult.message }}</span>
            </div>
          </div>

          <!-- In sync -->
          <div *ngIf="syncCompareResult.inSync" class="bg-green-900/20 border border-green-700/50 rounded-lg p-4 mb-4">
            <div class="flex items-center">
              <svg class="h-5 w-5 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              <span class="text-green-300 text-sm">{{ syncCompareResult.message }}</span>
            </div>
          </div>

          <!-- Differences found -->
          <div *ngIf="syncCompareResult.linked && !syncCompareResult.wcNotFound && !syncCompareResult.inSync">
            <div class="bg-orange-900/20 border border-orange-700/50 rounded-lg p-3 mb-4">
              <div class="flex items-center">
                <svg class="h-5 w-5 text-orange-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <span class="text-orange-300 text-sm">{{ syncCompareResult.message }}</span>
              </div>
            </div>

            <!-- Differences table -->
            <div class="overflow-x-auto max-h-80 overflow-y-auto rounded-lg border border-gray-700">
              <table class="min-w-full text-sm">
                <thead class="bg-gray-800 sticky top-0">
                  <tr>
                    <th class="px-3 py-2 text-left text-xs font-semibold text-gray-300 w-1/4">Veld</th>
                    <th class="px-3 py-2 text-left text-xs font-semibold text-indigo-400 w-[37.5%]">
                      <svg class="h-3 w-3 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" /></svg>
                      Firestore
                    </th>
                    <th class="px-3 py-2 text-left text-xs font-semibold text-purple-400 w-[37.5%]">
                      <svg class="h-3 w-3 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" /></svg>
                      WooCommerce
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-700/50">
                  <tr *ngFor="let diff of syncCompareResult.differences" class="hover:bg-gray-800/50">
                    <td class="px-3 py-2 text-gray-300 font-medium text-xs">{{ diff.field }}</td>
                    <td class="px-3 py-2 text-indigo-300 text-xs break-all">{{ diff.fsValue }}</td>
                    <td class="px-3 py-2 text-purple-300 text-xs break-all">{{ diff.wcValue }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Sync action buttons -->
            <div class="flex items-center justify-between mt-6 pt-4 border-t border-gray-700">
              <p class="text-xs text-gray-500">Kies een richting om te synchroniseren</p>
              <div class="flex items-center space-x-3">
                <button
                  type="button"
                  (click)="syncFromWoo()"
                  [disabled]="syncFromWooLoading || syncToWooLoading"
                  class="inline-flex items-center px-4 py-2 text-sm font-medium text-purple-300 bg-purple-900/30 border border-purple-700/50 rounded-lg hover:bg-purple-900/50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <svg *ngIf="syncFromWooLoading" class="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <svg *ngIf="!syncFromWooLoading" class="h-4 w-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                  </svg>
                  WOO &rarr; Firestore
                </button>
                <button
                  type="button"
                  (click)="syncToWoo()"
                  [disabled]="syncToWooLoading || syncFromWooLoading"
                  class="inline-flex items-center px-4 py-2 text-sm font-medium text-indigo-300 bg-indigo-900/30 border border-indigo-700/50 rounded-lg hover:bg-indigo-900/50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <svg *ngIf="syncToWooLoading" class="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <svg *ngIf="!syncToWooLoading" class="h-4 w-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
                  </svg>
                  Firestore &rarr; WOO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div *ngIf="deleteConfirmProduct" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="cancelDelete()"></div>
  <div class="flex min-h-full items-center justify-center p-4 sm:p-0">
    <div class="relative transform rounded-2xl bg-gradient-to-br from-gray-800 to-gray-900 px-6 pb-6 pt-6 text-left shadow-2xl sm:my-8 sm:w-full sm:max-w-md sm:p-8 border border-gray-700/50" (click)="$event.stopPropagation()">
      <div class="flex items-start space-x-4">
        <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-red-900/30">
          <svg class="h-6 w-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-white">Product verwijderen</h3>
          <p class="mt-2 text-sm text-gray-400">
            Weet je zeker dat je <span class="text-white font-medium">{{ deleteConfirmProduct.acf?.naam_nl || deleteConfirmProduct.id }}</span> wilt verwijderen? Dit kan niet ongedaan worden gemaakt.
          </p>
        </div>
      </div>
      <div class="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-700">
        <button
          type="button"
          (click)="cancelDelete()"
          class="px-4 py-2 text-sm font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
        >
          Annuleren
        </button>
        <button
          type="button"
          (click)="deleteProduct()"
          class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-500 rounded-lg transition-colors"
        >
          Verwijderen
        </button>
      </div>
    </div>
  </div>
</div>